"use strict";

exports.__esModule = true;
exports.ACTION_TYPE_DELIMITER = exports.DEFAULT_NAMESPACE = void 0;
var DEFAULT_NAMESPACE = '/';
exports.DEFAULT_NAMESPACE = DEFAULT_NAMESPACE;
var ACTION_TYPE_DELIMITER = '||';
exports.ACTION_TYPE_DELIMITER = ACTION_TYPE_DELIMITER;


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/constants.js
// module id = 642
// module chunks = 0